import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Widget } from '@social-solutions/ssg-forms';
import { toastr } from 'react-redux-toastr';
import * as userPreferencesActions from './user-preferences.actions';

export class UserPreferencesComponent extends Component {
  constructor(props) {
    super(props);

    const { auth } = props;
    const webVersion = auth.currentSession && auth.currentSession.user && auth.currentSession.user.webVersion;
    this.state = {
      useNewConnectWebUi: webVersion === 'new',
    };
  }

  handleSave() {
    const { auth, tenant, userPreferencesActions } = this.props;
    const { useNewConnectWebUi } = this.state;
    const participantId = auth.currentSession && auth.currentSession.user && auth.currentSession.user.id;
    const slug = tenant.currentTenant && tenant.currentTenant.slug;

    userPreferencesActions.updateWebVersion(participantId, { webVersion: useNewConnectWebUi ? 'new' : 'legacy' })
      .then(() => {
        if (useNewConnectWebUi) {
          toastr.success('Success', 'Preferences saved. Redirecting you to the new Connect UI...');
          setTimeout(() => {
            const newConnectUrl = process.env.NEW_CONNECT_URL.replace('{slug}', slug);
            window.location.href = `${newConnectUrl}?authToken=${auth.authToken}`;
          }, 2000);
        } else {
          toastr.success('Success', 'Preferences saved.');
        }
      })
      .catch(err => {
        toastr.error(err.errorCode, err.errorMessage);
      });
  }

  render() {
    const { tenant } = this.props;
    const integrationType = tenant.get("currentTenant").get("integrationType");

    if (process.env.HIDE_CONNECT_REWRITE_UI_TOGGLE === '1' || integrationType !== 'apricot') {
      return null;
    }

    const { userPreferences } = this.props;
    const { isFetching } = userPreferences || {};
    const { useNewConnectWebUi } = this.state;

    return (
      <Widget css={{ widgetDisplay: 'ssg-forms-widget account-widget' }}>
        <div>
          <h2 className="ssg-forms-text large account-widget-title">User Preferences</h2>
          <div className="ssg-forms-element">
            <label>
              <input
                type="checkbox"
                checked={useNewConnectWebUi}
                onChange={(e) => this.setState({ useNewConnectWebUi: e.target.checked })}
              />
              {' '}Use new Connect Web UI
            </label>
            <p>
              <small>
                * If you run into issues with the <strong>Updated Connect Web Interface</strong>, you can come back to this <i>User Preference</i> and switch back to the <strong>Legacy Connect Web Interface</strong>. If you do encounter any issues, please provide feedback about them so we can continue to improve the experience.
              </small>
            </p>
          </div>
          <div className="ssg-forms-plain-actions">
            <button
              className="ssg-forms-btn ssg-forms-btn-primary"
              disabled={isFetching}
              onClick={() => this.handleSave()}
            >
              {isFetching ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </Widget>
    );
  }
}

UserPreferencesComponent.propTypes = {
  auth: PropTypes.any.isRequired,
  tenant: PropTypes.any.isRequired,
  userPreferences: PropTypes.any.isRequired,
  userPreferencesActions: PropTypes.any.isRequired,
};

const mapStateToProps = ({ auth, tenant, userPreferences }) => ({
  auth,
  tenant,
  userPreferences,
});

const mapDispatchToProps = (dispatch) => ({
  userPreferencesActions: bindActionCreators(userPreferencesActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPreferencesComponent);



// WEBPACK FOOTER //
// src/acct/preferences/user-preferences.component.js